// components/WebinarModal.ts

export const createWebinarModal = () => {
  // Créer l'overlay de la modale
  const modalOverlay = document.createElement('div');
  modalOverlay.id = 'webinar-modal';
  modalOverlay.className = 'fixed inset-0 bg-black/60 backdrop-blur-sm z-50 hidden items-start justify-center p-4 overflow-y-auto pt-8 md:pt-12';
  modalOverlay.style.display = 'none';

  // Créer le conteneur de la modale
  const modalContainer = document.createElement('div');
  modalContainer.className = 'relative bg-white rounded-3xl shadow-2xl max-w-5xl w-full my-8 animate-modal-enter max-h-[90vh] overflow-y-auto';

  modalContainer.innerHTML = `
    <!-- Bouton de fermeture -->
    <button id="close-webinar-modal" class="absolute top-4 right-4 z-10 bg-white/90 hover:bg-white rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110" aria-label="Fermer">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>

    <!-- Contenu de la modale -->
    <div class="py-12 md:py-16 px-6 md:px-12 lg:px-16 relative overflow-hidden">
      <!-- Éléments décoratifs subtils -->
      <div class="absolute top-0 left-0 w-64 h-64 bg-[#133AC9]/5 rounded-full -ml-32 -mt-32"></div>
      <div class="absolute bottom-0 right-0 w-56 h-56 bg-[#497BF8]/5 rounded-full -mr-28 -mb-28"></div>

      <div class="relative max-w-4xl mx-auto">
        <!-- Badge date/heure -->
        <div class="text-center mb-6">
          <div class="flex items-center justify-center gap-3 text-gray-700 font-semibold flex-wrap mb-4">
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#133AC9]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span class="text-base md:text-lg">Date à confirmer</span>
            </div>
            <span class="text-xl text-[#497BF8]">•</span>
            <div class="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#133AC9]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              <span class="text-base md:text-lg">13h00</span>
            </div>
          </div>
        </div>

        <!-- Titre principal -->
        <h2 class="text-3xl md:text-4xl lg:text-5xl font-black text-center mb-4 leading-tight">
          <span class="gradient-text">Cryptoactifs : <br>les clés pour une gestion fiable de votre entreprise</span>
        </h2>

        <!-- Sous-titre -->
        <p class="text-center text-lg md:text-xl text-gray-600 mx-auto mb-8 leading-relaxed">
          <strong>Webinaire 1h :</strong> Intégrer sereinement les cryptoactifs dans votre gestion financière, comptable et juridique.
        </p>

        <!-- Formulaire d'inscription au webinaire -->
        <div class="bg-white rounded-2xl p-6 md:p-8 mb-10 border-2 border-[#133AC9]/20">
          <h3 class="text-center text-xl md:text-2xl font-bold text-gray-900 mb-6">Inscrivez-vous gratuitement</h3>
          <form id="webinarForm" class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- Prénom -->
              <div>
                <label for="firstName" class="block text-sm font-medium text-gray-700 mb-1">Prénom *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#133AC9] focus:border-transparent transition-colors"
                  placeholder="Votre prénom"
                />
              </div>

              <!-- Nom -->
              <div>
                <label for="lastName" class="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#133AC9] focus:border-transparent transition-colors"
                  placeholder="Votre nom"
                />
              </div>
            </div>

            <!-- Email -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-1">Email professionnel *</label>
              <input
                type="email"
                id="email"
                name="email"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#133AC9] focus:border-transparent transition-colors"
                placeholder="votre.email@entreprise.fr"
              />
            </div>

            <!-- Téléphone -->
            <div>
              <label for="phone" class="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#133AC9] focus:border-transparent transition-colors"
                placeholder="+33 6 12 34 56 78"
              />
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- Entreprise -->
              <div>
                <label for="company" class="block text-sm font-medium text-gray-700 mb-1">Entreprise *</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#133AC9] focus:border-transparent transition-colors"
                  placeholder="Nom de votre entreprise"
                />
              </div>

              <!-- Fonction -->
              <div>
                <label for="position" class="block text-sm font-medium text-gray-700 mb-1">Fonction *</label>
                <input
                  type="text"
                  id="position"
                  name="position"
                  required
                  class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#133AC9] focus:border-transparent transition-colors"
                  placeholder="Ex: DAF, Expert-comptable, CEO..."
                />
              </div>
            </div>

            <!-- Taille entreprise (optionnel) -->
            <div>
              <label for="companySize" class="block text-sm font-medium text-gray-700 mb-1">Taille de l'entreprise</label>
              <select
                id="companySize"
                name="companySize"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#133AC9] focus:border-transparent transition-colors"
              >
                <option value="">Sélectionnez...</option>
                <option value="1-10">1-10 employés</option>
                <option value="11-50">11-50 employés</option>
                <option value="51-200">51-200 employés</option>
                <option value="201-500">201-500 employés</option>
                <option value="500+">Plus de 500 employés</option>
              </select>
            </div>

            <!-- Bouton de soumission -->
            <button
              type="submit"
              class="w-full bg-gradient-to-r from-[#133AC9] to-[#497BF8] text-white font-black py-4 px-10 rounded-full text-lg shadow-2xl hover:shadow-3xl hover:scale-105 transform transition-all duration-300"
            >
              Je m'inscris gratuitement
            </button>

            <p class="text-xs text-gray-500 text-center mt-3">
              En vous inscrivant, vous acceptez de recevoir des informations relatives au webinaire.
            </p>
          </form>
        </div>

        <!-- Pourquoi ce webinaire -->
        <div class="mb-10 text-left">
          <h3 class="mt-20 mb-20 text-2xl md:text-3xl font-bold text-gray-900 mb-4">Pourquoi ce webinaire ?</h3>
          <p class="text-gray-700 mb-4 leading-relaxed">
            Les cryptoactifs entrent dans le bilan des entreprises. Ce n'est plus un sujet de niche, c'est une réalité économique. Pourtant, un sentiment de flou persiste souvent :
          </p>
          <div class="bg-gray-50 rounded-xl p-6 mb-4 border-l-4 border-[#133AC9]">
            <p class="text-gray-700 italic mb-2">"Comment intégrer ça dans ma compta sans tout casser ?"</p>
            <p class="text-gray-700 italic mb-2">"Quelles sont les règles du jeu actuelles ?"</p>
            <p class="text-gray-700 italic">"Comment sécuriser mes opérations ?"</p>
          </div>
          <p class="text-center text-gray-700 leading-relaxed">
            <strong class="text-xl text-[#133AC9]">La bonne nouvelle ?</strong> <br>La réglementation se stabilise et les outils se professionnalisent.
          </p>
        </div>

        <!-- Ce que nous allons partager -->
        <div class="mb-10 text-left">
          <h3 class="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Ce que nous allons partager</h3>
          <p class="text-gray-700 mb-6 leading-relaxed">
            Loin des discours anxiogènes, nous vous proposons une approche pragmatique pour normaliser votre gestion crypto.
          </p>

          <div class="space-y-6">
            <!-- Point 1 -->
            <div class="bg-gradient-to-br from-[#133AC9]/5 to-[#133AC9]/10 rounded-2xl p-6 border-2 border-[#133AC9]/20">
              <div class="flex items-start gap-4">
                <div class="w-12 h-12 bg-[#133AC9] rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                </div>
                <div>
                  <h4 class="text-xl font-bold text-[#133AC9] mb-2">1. Les réflexes de gestion</h4>
                  <p class="text-gray-700">Nous avons traduit les contraintes techniques en bonnes pratiques de gestion. <br>Comment tracer, valoriser et sécuriser vos actifs simplement.</p>
                </div>
              </div>
            </div>

            <!-- Point 2 -->
            <div class="bg-gradient-to-br from-[#133AC9]/5 to-[#133AC9]/10 rounded-2xl p-6 border-2 border-[#133AC9]/20">
              <div class="flex items-start gap-4">
                <div class="w-12 h-12 bg-[#133AC9] rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                  </svg>
                </div>
                <div>
                  <h4 class="text-xl font-bold text-[#133AC9] mb-2">2. La régulation comme alliée</h4>
                  <p class="text-gray-700">Comprendre MiCA et DAC8 non pas comme des menaces, mais comme un cadre qui sécurise enfin votre activité et vos relations bancaires.</p>
                </div>
              </div>
            </div>

            <!-- Point 3 -->
            <div class="bg-gradient-to-br from-[#133AC9]/5 to-[#497BF8]/10 rounded-2xl p-6 border-2 border-[#133AC9]/20">
              <div class="flex items-start gap-4">
                <div class="w-12 h-12 bg-gradient-to-br from-[#133AC9] to-[#497BF8] rounded-xl flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                  </svg>
                </div>
                <div>
                  <h4 class="text-xl font-bold text-[#133AC9] mb-2">3. Les outils modernes</h4>
                  <p class="text-gray-700">Pourquoi l'automatisation est la clé pour piloter vos cryptoactifs avec la même fluidité que vos comptes bancaires classiques.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Intervenants -->
        <div class="bg-gray-50 rounded-2xl p-6 md:p-8 mb-8 border border-gray-200">
          <h3 class="text-center text-xl font-bold text-gray-900 mb-6">Les intervenants</h3>
          <div class="flex flex-col md:flex-row justify-center items-stretch gap-6 md:gap-8 max-w-3xl mx-auto">
            <div class="flex-1 text-center flex flex-col items-center">
              <div class="w-32 h-32 md:w-40 md:h-40 rounded-full mb-3 overflow-hidden border-2 border-[#133AC9]">
                <img src="assets/images/PhotoSanaaMoussaid.webp" alt="Sanaa MOUSSAID" width="600" height="600" class="w-full h-full object-cover" loading="lazy" decoding="async">
              </div>
              <p class="font-bold text-gray-900 text-base md:text-lg">Sanaa MOUSSAID</p>
              <p class="text-gray-600 text-sm mb-2">Crypto Accounting</p>
              <p class="text-sm text-gray-700 italic">Elle connecte le monde de la finance décentralisée avec les standards de la gestion d'entreprise.</p>
            </div>

            <div class="hidden md:block w-px bg-gray-300 self-stretch"></div>

            <div class="flex-1 text-center flex flex-col items-center">
              <div class="w-32 h-32 md:w-40 md:h-40 rounded-full mb-3 overflow-hidden border-2 border-[#497BF8]">
                <img src="assets/images/arnaud-touati-interview.jpg" alt="Arnaud TOUATI" width="600" height="600" class="w-full h-full object-cover" loading="lazy" decoding="async">
              </div>
              <p class="font-bold text-gray-900 text-base md:text-lg">Arnaud TOUATI</p>
              <p class="text-gray-600 text-sm mb-2">Hashtag Avocats</p>
              <p class="text-sm text-gray-700 italic">Il décrypte le cadre légal pour sécuriser votre business.</p>
            </div>
          </div>
        </div>

        <!-- Bouton d'inscription après les intervenants -->
        <div class="text-center mb-10">
          <button
            type="button"
            onclick="document.getElementById('webinarForm').scrollIntoView({ behavior: 'smooth', block: 'center' })"
            class="w-full md:w-auto bg-gradient-to-r from-[#133AC9] to-[#497BF8] text-white font-black py-4 px-10 rounded-full text-lg shadow-2xl hover:shadow-3xl hover:scale-105 transform transition-all duration-300"
          >
            Je m'inscris gratuitement
          </button>
        </div>

        <!-- Footer info -->
        <div class="text-center text-gray-600">
          <p class="text-sm">
            <strong>Pour qui ?</strong> DAF, dirigeants, experts-comptables souhaitant des réponses claires.
          </p>
        </div>
      </div>
    </div>
  `;

  modalOverlay.appendChild(modalContainer);

  // Fonction pour ouvrir la modale
  const openModal = () => {
    modalOverlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    // Animation d'entrée
    setTimeout(() => {
      modalOverlay.classList.remove('hidden');
    }, 10);
  };

  // Fonction pour fermer la modale
  const closeModal = () => {
    modalOverlay.classList.add('hidden');
    setTimeout(() => {
      modalOverlay.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  };

  // Gestionnaire d'événements pour le bouton de fermeture
  const closeButton = modalContainer.querySelector('#close-webinar-modal');
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  // Fermer en cliquant sur l'overlay
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) {
      closeModal();
    }
  });

  // Fermer avec la touche Échap
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalOverlay.style.display === 'flex') {
      closeModal();
    }
  });

  // Ajouter la modale au body
  document.body.appendChild(modalOverlay);

  // Retourner les fonctions pour contrôler la modale
  return {
    open: openModal,
    close: closeModal,
    element: modalOverlay
  };
};
